export type IntentHandler = (payload: any) => void;

const intentHandlers: Record<string, IntentHandler> = {};

export const registerIntentHandler = (intent: string, handler: IntentHandler): void => {
    intentHandlers[intent] = handler;
};

export const dispatchIntent = (intent: string, payload: any): void => {
    if (intentHandlers[intent]) {
        intentHandlers[intent](payload);
    } else {
        console.warn(`No handler registered for intent: ${intent}`);
    }
};
